import dayjs from "dayjs";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  useDeleteEventById,
  useEndEventById,
} from "../../../../../api/inquiries/event/use-event";
import { useEventById } from "../../../../../api/inquiries/event/use-event-detail";
import TitlePage from "../../../../../components/section/TitlePage/Titlepage";
import Button from "../../../../../components/ui/Button/Button";
import Modal from "../../../../../components/ui/Modal/Modal";
import EditorViewer from "../../../../../components/EditorViewer";

const EventDetailPage = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { data } = useEventById(id);
  const { mutate: deleteEventById } = useDeleteEventById();
  const { mutate: endEventById } = useEndEventById(id);
  const eventData = data?.data;

  const handleBack = () => {
    navigate("/bulletin-board");
  };

  const handleEdit = () => {
    navigate("edit");
  };

  const onDeleteEvent = async () => {
    deleteEventById(id);
  };

  const onEndEvent = async () => {
    endEventById(id);
  };

  return (
    <>
      <div>
        <TitlePage
          title="이벤트 > 이벤트 상세 (ONEDAY Mall 이벤트)"
          customElements={
            <div className="flex justify-end">
              <Button width="w-24" onClick={handleBack} text="목록" />
              <Modal
                lineHeight="leading-[1.75]"
                description={
                  <span>
                    해당 이벤트를 종료하시겠습니까?
                    <br />
                    이벤트가 종료될 경우, 병원웹/앱에 이벤트 종료로 표시가
                    됩니다.
                    <br />
                    <br />
                    <br />
                    이미 종료된 이벤트를 추후에 다시 활용할 경우, [수정]을
                    통하여 '이벤트
                    <br />
                    시작일'과 '이벤트 종료일'을 변경해주시면 다시 이벤트가
                    '진행중'으로
                    <br />
                    변경됩니다.{" "}
                  </span>
                }
                submitText="이벤트 종료"
                onSubmit={onEndEvent}
                maxWidth="max-w-[25rem]"
              >
                <Button
                  width="w-24"
                  text="이벤트 종료"
                  isDisabled={eventData?.status === "FINISHED"}
                />
              </Modal>
              <Modal
                description={
                  <span>
                    해당 항목을 삭제하시겠습니까? <br />
                    삭제할 경우 데이터 복구가 불가능합니다.
                  </span>
                }
                onSubmit={onDeleteEvent}
              >
                <Button width="w-24" text="삭제" />
              </Modal>
              <Button onClick={handleEdit} primary width="w-24" text="수정" />
            </div>
          }
        />
        <div className="mt-4">
          <div className="flex items-center">
            <div className="w-1/3">
              <div className="flex w-full">
                <div className="flex items-center flex-none text-[12px] border border-r-0 text-black border-primary-grey bg-input-grey p-2 w-[150px]">
                  등록 상태
                </div>
                <div className="p-2 border grow">
                  {eventData?.status === "FINISHED" ? (
                    "이벤트 종료"
                  ) : (
                    <span className="text-[#e80000]">진행중</span>
                  )}
                </div>
              </div>
            </div>
            <div className="w-1/3">
              <div className="flex w-full">
                <div className="flex items-center flex-none text-[12px] border border-r-0 text-black border-primary-grey bg-input-grey p-2 w-[150px]">
                  등록일시
                </div>
                <div className="p-2 border grow">
                  {dayjs(eventData?.createdAt).format("YYYY-MM-DD HH:mm")}
                </div>
              </div>
            </div>
            <div className="w-1/3">
              <div className="flex w-full">
                <div className="flex items-center flex-none text-[12px] border border-r-0 text-black border-primary-grey bg-input-grey p-2 w-[150px]">
                  조회수
                </div>
                <div className="p-2 border grow">{eventData?.hitLog || 0}</div>
              </div>
            </div>
          </div>
          <div className="flex items-center">
            <div className="w-1/3">
              <div className="flex w-full">
                <div className="flex items-center flex-none text-[12px] border border-r-0 text-black border-primary-grey bg-input-grey p-2 w-[150px]">
                  이벤트 시작일
                </div>
                <div className="p-2 border grow">
                  {" "}
                  {dayjs(eventData?.startDate).format("YYYY-MM-DD")}
                </div>
              </div>
            </div>
            <div className="w-2/3">
              <div className="flex w-full">
                <div className="flex items-center flex-none text-[12px] border border-r-0 text-black border-primary-grey bg-input-grey p-2 w-[150px]">
                  이벤트 종료일
                </div>
                <div className="p-2 border grow text-black">
                  <span
                    className={`${
                      eventData?.status === "FINISHED"
                        ? "text-[#000]"
                        : "text-[#e80000]"
                    }`}
                  >
                    {dayjs(eventData?.endDate).format("YYYY-MM-DD")}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="flex items-center">
            <div className="w-full">
              <div className="flex w-full">
                <div className="flex items-center flex-none text-[12px] border border-r-0 text-black border-primary-grey bg-input-grey p-2 w-[150px]">
                  이벤트 배너
                </div>
                <div className="p-2 border flex-wrap items-center gap-4 grow">
                  <div className="relative w-[380px] h-[140px] border border-[#cccccc]">
                    <img
                      src={eventData?.mainImg}
                      className="object-cover w-full h-full"
                      alt="event"
                    />
                  </div>
                  <div className="mt-2 text-[#999999] text-[11px]">
                    ※ 이벤트 배너 권장 사이즈 : WEB(PC) 기준 570x220. APP은
                    WEB(PC)기준으로 리사이징 됩니다.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex items-center">
            <div className="w-full">
              <div className="flex w-full">
                <div className="flex items-center flex-none text-[12px] border border-r-0 text-black border-primary-grey bg-input-grey p-2 w-[150px]">
                  이벤트 제목
                </div>
                <div className="p-2 border flex-wrap items-center gap-4 grow">
                  <span className="text-black">{eventData?.title}</span>
                </div>
              </div>
            </div>
          </div>
          <div className="flex items-center">
            <div className="w-full">
              <div className="flex w-full">
                <div className="flex items-center flex-none text-[12px] border border-r-0 text-black border-primary-grey bg-input-grey p-2 w-[150px]">
                  이벤트 내용
                </div>
                <EditorViewer
                  delta={JSON.parse(eventData?.contents)}
                  className="border flex-wrap items-center p-2 gap-4 grow"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EventDetailPage;
